import React from 'react'
import { Route, Routes, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { creditApplicationEffects, creditApplicationSelectors } from '../../data/store/CreditApplicationStore'
import { useSideEffect } from '../../data/store/Effects/side-effects'
import RefinancingCreditApplicationForm from './RefinancingCreditApplicationForm'
import { RefinancingCreditApplication } from '../../data/types/RefinancingCreditApplication'
import { useAppSelector } from '../../data/store'
import { formatDate } from '../utils/utils'
import Loader from '../components/Loader'

function RefinancingCreditApplicationContainer() {
  const { id } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatchEffect = useSideEffect()

  const refinancingCreditApplicationIsLoading = useAppSelector(
    creditApplicationSelectors.RefinancingCreditApplicationIsLoading,
  )
  const onSubmit = (data: RefinancingCreditApplication) => {
    dispatchEffect(creditApplicationEffects.postRefinancingCreditApplication(data)).then(() =>
      navigate(`/refinancingCreditApplication/${id}/confirmation`, { replace: true }),
    )
  }

  React.useEffect(() => {
    if (id) dispatchEffect(creditApplicationEffects.getRefinancingCreditApplication(id))
  }, [id])

  const refinancingCreditApplication = useAppSelector(creditApplicationSelectors.getRefinancingCreditApplication)

  const canRefinancing = (): boolean => {
    if (
      (refinancingCreditApplication?.availableAmount as number) < 500 ||
      formatDate(refinancingCreditApplication?.expiresOn) < formatDate(new Date())
    )
      return false
    return true
  }

  const showForm = canRefinancing()

  return (
    <div>
      {refinancingCreditApplicationIsLoading && <Loader description="" title={t('common.withYouShortly')} />}
      {!refinancingCreditApplicationIsLoading && !showForm && (
        <main className="general-message">
          <h4 className="subtitle">{t<string>('common.financeApplication')}</h4>
          <h1>{t<string>('refinancing.noRefinancing')}</h1>
        </main>
      )}
      {!refinancingCreditApplicationIsLoading && showForm && (
        <div>
          <Routes>
            <Route path="*" element={<RefinancingCreditApplicationForm onSubmit={onSubmit} />} />
            <Route
              path="/confirmation"
              element={
                <main className="general-message">
                  <h4 className="subtitle">{t<string>('common.financeApplication')}</h4>
                  <h1>
                    #{refinancingCreditApplication?.referenceNumber} {t<string>('refinancing.confirmation.inReview')}
                  </h1>
                  <div className="paragraph">
                    <p>{t<string>('refinancing.confirmation.messageLine1')}.</p>
                    <p>{t<string>('refinancing.confirmation.messageLine2')}</p>
                  </div>
                </main>
              }
            />
          </Routes>
        </div>
      )}
    </div>
  )
}

export default RefinancingCreditApplicationContainer
